import React, { useState, useRef } from 'react';
import { Button, Alert, message } from 'antd';
import { VerifyErps } from '@/apis/commonService/VerifyErps';
import './index.less';
import AddErpUser from '@/components/add-erp-user';

function findSame(arr = [], sourceArr = []) {
  const theSame = [];
  const theDiff = [];
  arr.map((item) => {
    if (sourceArr.find((ele) => ele.erp == item.erp)) {
      theSame.push(item.erp);
    } else {
      theDiff.push(item);
    }
  });
  return { theSameErp: theSame, theDiff: theDiff };
}

function ActMemberSetting(props) {
  const { value = [], onChange, isEdit } = props;
  // const [visible, setVisible] = useState(false);

  const [member, setMember] = useState(value);
  // const [erps, setErps] = useState(''); // 输入框中的值

  const addErpRef = useRef(null);

  const memberRef = useRef(member);
  memberRef.current = member;

  const submit = () => {
    addErpRef.current.close();
    onChange(memberRef.current);
  };

  const openAddErp = () => {
    setMember(value);
    addErpRef.current.open({
      type: 'list',
      title: '添加管理组成员',
      footer: (
        <div>
          <Button onClick={() => addErpRef.current.close()} shape="round">
            取消
          </Button>
          <Button type="primary" onClick={submit} shape="round">
            确定
          </Button>
        </div>
      ),
      extraDis: (
        <Alert
          message=""
          description={
            <>
              <div>
                1.
                管理组成员具有对活动的收品池管理、场次管理、资源分配及素材终审权限,管理组成员还可以在通天塔里关联素材组；
              </div>
              <div>2. 仅管理组组长具有增删活动管理组成员、收品池管理员的权限,组长可转让；</div>
              <div>3. 活动管理组成员（包含组长）不得超过10人；</div>
              <div>4. 活动管理组成员不可被添加为收品池管理员，收品池管理员也不可被添加为活动管理员；</div>
            </>
          }
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      ),
      onOk: onAddErpSuccess,
      fetchErpList() {
        return Promise.resolve(memberRef.current.map((e) => ({ erp: e.erp, erpRealName: e.realName })));
      },
      onDeleteItem(item, onDeleteSuccess) {
        setMember((member) => {
          return member.filter((ele) => ele.erp != item.erp);
        });
        onDeleteSuccess();
      },
    });
  };

  const onAddErpSuccess = (nowformData, successCallBack) => {
    VerifyErps({ erps: nowformData.erps }).then((res) => {
      const { ret, data, msg } = res;
      if (ret != 0 || !data) {
        message.error(msg || '接口校验失败，请稍后重试！');
        return;
      }
      const { validErps = [], invalidErps = [] } = data;
      const { theSameErp, theDiff } = findSame(validErps, memberRef.current);

      if (theDiff.length > 0) setMember((member) => member.concat(theDiff));

      const reasons = [];
      if (invalidErps.length > 0 || theSameErp.length > 0) {
        invalidErps.length > 0 && reasons.push({ erps: invalidErps.toString(), reason: '以下erp无效' });
        theSameErp.length > 0 && reasons.push({ erps: theSameErp.toString(), reason: '以下erp重复' });
      }
      successCallBack({
        success: theDiff.length,
        failure: invalidErps.length + theSameErp.length,
        reasons: reasons,
      });
    });
  };

  return (
    <div className="room-activity-member-setting">
      {value.map((item, index) => (
        <div key={index}>
          {item.erp}
          {item.isLeader == 1 && '（组长）'}
        </div>
      ))}
      {!isEdit && (
        <Button type="primary" onClick={openAddErp}>
          设置
        </Button>
      )}
      <AddErpUser ref={addErpRef} />
    </div>
  );
}

export default ActMemberSetting;
